export default __webpack_public_path__ + "static/icon-c8dd627c08dffc67fcce37442d316756.png";